function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group 56804"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M33.5469 5.9375H4.45312C4.28984 5.9375 4.15625 6.07109 4.15625 6.23438V8.60938C4.15625 8.77266 4.28984 8.90625 4.45312 8.90625H33.5469C33.7102 8.90625 33.8438 8.77266 33.8438 8.60938V6.23438C33.8438 6.07109 33.7102 5.9375 33.5469 5.9375ZM33.5469 29.0938H4.45312C4.28984 29.0938 4.15625 29.2273 4.15625 29.3906V31.7656C4.15625 31.9289 4.28984 32.0625 4.45312 32.0625H33.5469C33.7102 32.0625 33.8438 31.9289 33.8438 31.7656V29.3906C33.8438 29.2273 33.7102 29.0938 33.5469 29.0938ZM33.5469 17.5156H4.45312C4.28984 17.5156 4.15625 17.6492 4.15625 17.8125V20.1875C4.15625 20.3508 4.28984 20.4844 4.45312 20.4844H33.5469C33.7102 20.4844 33.8438 20.3508 33.8438 20.1875V17.8125C33.8438 17.6492 33.7102 17.5156 33.5469 17.5156Z",
  fill: "white"
}));

var SvgSlidebarBtn = function SvgSlidebarBtn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSlidebarBtn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slidebar_btn.1452331c.svg";
export { ForwardRef as ReactComponent };